import React from "react";

import clsx from "clsx";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import NativeSelect from "@meetyoo/components/src/components/Selects/NativeSelect";

export const defaultPasscodeTheme = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  lineBreak: {
    width: "100%",
  },
  lineExpander: {
    flexGrow: 1,
  },
  switch: {
    margin: theme.spacing(1, 1, 1, 1),
    width: "5%",
  },
  button: {
    margin: theme.spacing(2, 1, 1, 1),
  },
  centerer: {
    textAlign: "center",
    width: "100%",
  },
  inline: {
    display: "flex",
    width: "100%",
  },
});

export const getKeyFromSelectedValue = (object, selectedValue) => {
  return Object.keys(object).filter(storeKey => object[storeKey] === selectedValue)[0];
};

export const getSelectedValueTranslated = (selectedValue, selectableValues, selectKey) => {
  return selectableValues[selectKey][selectedValue];
};

export const getSelectValues = (selectableValues, selectKey) => {
  return Object.keys(selectableValues[selectKey]).map(key => selectableValues[selectKey][key]);
};

export const textfield = (classes, isDesktop, value, label, onChange) => (
  <TextField
    id="standard-name"
    label={label}
    className={clsx(classes.textField, {
      [classes.lineExpander]: isDesktop,
      [classes.textFieldMobile]: !isDesktop,
    })}
    value={value || ""}
    onChange={onChange}
    margin="normal"
  />
);

export const switchControl = (classes, checked, value, label, onChange) => {
  const isChecked = checked === 1 || checked === true;
  return (
    <FormControlLabel
      className={`${classes.switch} ${classes.lineExpander}`}
      control={<Switch checked={isChecked} onChange={onChange} value={value} color="primary" />}
      label={label}
    />
  );
};

export const selectField = (customStyle, value, selectValues, defaultSelect, onChange) => (
  <NativeSelect
    customStyle={customStyle}
    value={value}
    defaultSelect={defaultSelect}
    selectValues={selectValues}
    onChange={onChange}
  />
);
